import { render, staticRenderFns } from "./resultChart.vue?vue&type=template&id=bf3c0416&lang=pug&"
import script from "./resultChart.vue?vue&type=script&lang=ts&"
export * from "./resultChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports